import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import 'moment/locale/ar';
@Pipe({
  name: 'dateTime'
})
export class DateTimePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}
  transform(value: any, args: any = this.translateService.currentLang === 'ar' ? 'DD/MM/YYYY' : 'YYYY/MM/DD'): any {
    if (moment(value).isValid())
      return moment(value)
        .locale(this.translateService.currentLang)
        .format(args);
    return value;
  }
}
